var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.posts, function (post) {
        return _c("post-card", { key: post.id, attrs: { post: post } })
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "more-posts" },
        [
          _c("q-button", { on: { click: _vm.morePosts } }, [
            _c("span", [_vm._v(_vm._s(this.$qt("blog.morePostsText")))]),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }